import { BillingType } from '@pncl/common-models';
import { PaywallConfig } from '../admin/types.interface';
import { PaymentPlan } from '../models/payment';

/**
 * Builds institution paywallConfig from the PaymentPlan being subscribed to.
 * Does not merge prior institution paywall — FE apply follows the plan only.
 *
 * V2 plans (enableV2Billing === true): copy flag + stepPricingConfiguration.
 * Non-V2 (e.g. trial / legacy): enableV2Billing false, no stepPricingConfiguration.
 */
export function buildPaywallConfigFromPaymentPlan(
  paymentPlan: Partial<PaymentPlan>,
): PaywallConfig {
  const isV2Plan = paymentPlan.enableV2Billing === true;

  const paywallConfig: PaywallConfig = {
    billingStrategy: paymentPlan.billingStrategy,
    billingType: BillingType.Automatic,
    hostDiscountFlag: false,
    billingConfiguration: paymentPlan.billingConfiguration,
    enableV2Billing: isV2Plan,
  };

  if (isV2Plan && paymentPlan.stepPricingConfiguration) {
    paywallConfig.stepPricingConfiguration = paymentPlan.stepPricingConfiguration;
  }

  return paywallConfig;
}
